import { HttpClient } from "./httpClient";
import { get } from "lodash";
import { getQueryVariable } from "./jobInfo";

const getCookie = (cname) => {
  if(!cname)cname = window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};
const kxToken = getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN);
const getRequestHeaders = () => {
  return {
    "Content-Type": "application/json",
    kxToken: kxToken,
  };
};
export const getShipment = async (context) => {
  if (context.props.shipId === "NoJobsAvailabe") return;
  let dataShipment = {
    eventMessage: context.props.shipId,
    eventType: "FETCH_SHIPMENT_BROKER",
    eventTime: Date.now(),
  };
  let dataDocs = {
    eventMessage: { id: context.state.selectedKxShipmentId },
    eventType: "GET_SHIPMENT_DOCUMENTS",
    eventTime: Date.now(),
  };
  let fetchShipment = HttpClient.custom({
    data: dataShipment,
  });
  let getShipmentDocuments = HttpClient.custom({
    data: dataDocs,
  });
  try {
    const fetchShipmentResponse = await fetchShipment;
    const getShipmentDocumentsResponse = await getShipmentDocuments;
    let customerEmail = get(
      fetchShipmentResponse,
      "data.eventMessage.shipment.customerEmail",
      null
    );
    let selectedShipment = get(
      fetchShipmentResponse,
      "data.eventMessage.shipment",
      null
    );
    let documents = get(
      getShipmentDocumentsResponse,
      "data.eventMessage.documents",
      null
    );
    context.setState({
      // Set parent's props
      startTime: Date.now(),
      customerEmail,
      selectedShipment,
    });
    if (documents) {
      let docs = [];
      let newList = documents.filter((doc) => {
        if (doc.hasOwnProperty("remoteurl")) {
          let url = doc.remoteurl.split("/");
          url = url[url.length - 1];
          docs.push(url);
          return doc;
        }
      });
      getSignedUrls({ files: docs })
        .then((res) => {
          newList.map((url, index) => {
            res.data.eventMessage.urls.forEach((doc, i) => {
              if (index === i) {
                url.remoteurl = doc;
              }
            });
          });
          context.setState({
            allDocs: {...context.state.allDocs, [context.state.selectedKxShipmentId]:newList},
            currentDocId: newList[0].docid,
            currentDocIndex: 0,
            errorDocuments: false,
            docUrlNames: {...context.state.docUrlNames, [context.state.selectedKxShipmentId]:docs},
          });
          getTextGroup(context, newList[0].docid.toString(), 0);
        })
        .catch((err) => console.error("get_signed_urls error", err));
    } else {
      context.setState({
        errorDocuments: 
        {...context.state.errorDocuments, [context.state.selectedKxShipmentId]:
          `We did not find any documents for shipment ${context.state.selectedKxShipmentId}`},
        currentDocId: null,
        currentDocIndex: 0,
      });
    }
    return fetchShipmentResponse;
  } catch (err) {
    console.log("Fetch Shipment Error", err);
    return context.setState({
      loadingItems: "Error on FETCH_SHIPMENT!",
      errorDocuments: 
        {...context.state.errorDocuments, [context.state.selectedKxShipmentId]:
        `Oops! We could not get the documents for shipment "${context.state.selectedKxShipmentId}" at this time.`},
      currentDocId: null,
      currentDocIndex: 0,
    });
  }
};
export const getURNumber = (fillercode, shipmentId='') => {
  // const shipId = getQueryVariable('shipmentKxHttpId')
  // const docId = getQueryVariable('docId')
  // console.log({shipId_:shipId, docId})
  const data = {
    eventMessage: { filerCode: `${fillercode}`, shipmentId },
    eventType: "GET_TRANSACTION_NUM_FOR_DIF",
    eventTime: Math.floor(Date.now() / 1000),
  };
  return HttpClient.custom({
    data,
  });
};
export const getTextGroup = (context, docid, index) => {
  const textGroups = context?.state?.textGroups || {};
  if (textGroups[docid]) {
    return;
  }
  const data = {
    eventMessage: docid,
    eventType: "GET_TEXT_GROUP",
    eventTime: Math.floor(Date.now() / 1000),
  };

  return HttpClient.custom({
    data,
  })
    .then((response) => {
      context.setState({
        textGroups: {...textGroups, [docid]: response.data.eventMessage.elements.texts}
      });
    })
    .catch((error) => {
      console.error(
        `Error on GET_TEXT_GROUP for doc:${docid}. Error: ${error}`
      );
    });
};

export const addDocument = (shipId, docNames) => {
  let data = {
    eventMessage: `${shipId},${docNames}`,
    eventType: "ADD_DOCUMENT",
    eventTime: Date.now(),
  };

  return HttpClient.addDoc({
    data,
  });
};

export const fileStatementUpdateRequest = (eventMessage) => {
  let data = {
    eventMessage: eventMessage,
    eventType: "FILE_STATEMENT_UPDATE_REQUEST",
    eventTime: Date.now(),
  };

  return HttpClient.addDoc({
    data,
  });
};

export const getStatementUpdateStatusRequest = (eventMessage) => {
  let data = {
    eventMessage: eventMessage,
    eventType: "GET_STATEMENT_UPDATE_STATUS_REQUEST",
    eventTime: Date.now(),
  };

  return HttpClient.custom({
    data,
  });
};

export const addNewDocument = (shipId, docNames, docType, userBasicInfo) => {
  let documents_h = [];
  for (let docname of docNames) {
    documents_h.push({
      documentName: docname,
      // fullProcess: "FULL"
      documentType: docType,
      fullProcess: "SKIP OCR",
      // "displayName": "CBP03 - Other",
      // "replaceOldVersion": false
    });
  }
  let data = {
    eventMessage: `${shipId},${docNames}`,
    eventMessage: {
      shipmentId: shipId,
      documentDetails: documents_h,
      fullName: userBasicInfo.fullName,
      userType: "BROKER",
    },
    eventType: "ADD_DOCUMENT_NEW",
    eventTime: Date.now(),
  };

  return HttpClient.addDoc({
    data,
  });
};


export const docUploaded = (shipId, documentType, docName, eventType) => {
    let data = {
        "eventMessage": {
            "shipmentId": shipId,
            "documentType": documentType,
            "documentName": docName
    },
    "eventType": eventType,
    "eventTime": Date.now()
  }
  return HttpClient.custom({
    data,
  });
}

export const fetchAddDocumentStatus = (uploadId) => {
  const data = {
    eventMessage: uploadId.toString(),
    eventType: "ADD_DOCUMENT_STATUS",
    eventTime: Date.now(),
  };

  return HttpClient.custom({
    data,
  });
};

export const fileUpload = (shipId, docNames, config) => {
  let data = {
    files: docNames,
    eventType: "FILE_UPLOAD",
    eventTime: Date.now(),
  };

  return HttpClient.fileUpload(
    {
      data,
    },
    config,
    shipId
  );
};

export const getPDFs = (shipId, type) => {
  let data = {
    eventMessage: {
      shipmentId: shipId,
      pdfType: type,
      signDate: `${((new Date().getMonth()+1)+"").padStart(2, '0')}${(new Date().getDate()+"").padStart(2, '0')}${((new Date().getFullYear()%100)+"").padStart(2, '0')}`,
    },
    eventType: "GENERATE_PDF",
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};

export const getSignedUrls = ({ bucket, files }) => {
  let url = bucket ? bucket + ":" + files.join(",") : files.join(",");
  let eventMessage = url.split(',')[0]
  if(window.shipmentCountry === "US" || window.shipmentCountry === "CA"){
    eventMessage = bucket ? bucket + ":" + files.join(",") : files.join(",");
  }

  let data = {
    eventMessage,
    eventType: "GET_SIGNED_URLS",
    eventTime: Date.now(),
  };

  return HttpClient.custom({
    data,
  });
};

export const getHistoryDocuments = (shipmentId) =>{
  const data = {
    "eventMessage":{
       shipmentId
    },
    "eventType":"FETCH_CBP_DIS_HISTORY",
    "eventTime":Date.now()
  }

  return HttpClient.custom({
    data
  })
}
export const getPreSignedUrls = (bucket, fileName) => {
  let eventMessage = {
    "bucketName": bucket,
    "keyName": fileName
  }

  let data = {
    eventMessage,
    eventType: "GET_PRE_SIGNED_URL",
    eventTime: Date.now(),
  };

  return HttpClient.custom({
    data,
  });
};


export const downloadInvoiceSignedUrl = (bucketName, fileName) => {
  return HttpClient.custom({
    url: HttpClient.baseUrl,
    headers: getRequestHeaders(),
    data: {
      eventMessage: `${bucketName}:${fileName}`,
      eventType: "GET_SIGNED_URLS",
      eventTime: Date.now(),
    },
    method: "post",
  });
};

export const generateDISEmail = (shipId) => {
  let body = {
    eventMessage: shipId,
    eventType: "GET_DIS_DATA",
    eventTime: Date.now(),
  };

  return HttpClient.custom({
    data: body,
  });
};
export const get_DOCUMENT_TYPES_apx = (shipId) => {
  let body = {
    eventMessage: "",
    eventType: "GET_DOCUMENT_TYPES",
    eventTime: Date.now(),
  };

  return HttpClient.custom({
    data: body,
  });
};
export const CREATE_DIS_USER_REQUEST_apx = (shipId) => {
  let body = {
    eventMessage: {
      shipmentId: shipId,
    },
    eventType: "CREATE_DIS_USER_REQUEST",
    eventTime: Date.now(),
  };

  return HttpClient.custom({
    data: body,
  });
};

export const get_DIF_STATUS_apx = (shipId, modalrequestid) => {
  let body = {
    eventMessage: {
      requestid: modalrequestid,
      // docType: "BOL"
    },
    eventType: "GET_DIF_STATUS",
    eventTime: Date.now(),
  };

  return HttpClient.custom({
    data: body,
  });
};

export const get_DIF_REQUEST_apx = (onedoctype, modalrequestid) => {
  let body = {
    eventMessage: {
      requestid: modalrequestid, //specific to every modal!
      docType: onedoctype,
      txnNumber: window.transactionNumber,
    },
    eventType: "GET_DIF_REQUEST",
    eventTime: Date.now(),
  };
  return HttpClient.addDoc({
    data: body,
  });
};
export const add_document_status_apx = (docnumber) => {
  console.log("docnumber: ", docnumber);
  let body = {
    eventMessage: docnumber + "",
    eventType: "ADD_DOCUMENT_STATUS",
    eventTime: Date.now(),
  };

  return HttpClient.custom({
    data: body,
  });
};

export const add_document_new_apx = (
  shipId,
  filenamepdf,
  newdoctype,
  userBasicInfo
) => {
  let documents_h = [];
  for (let docname of [filenamepdf]) {
    documents_h.push({
      documentName: docname,
      fullProcess: "SKIP OCR",
      documentType: "0",
      displayName: `${newdoctype.key} - ${newdoctype.value}`,
      // "replaceOldVersion": false
    });
  }
  let body = {
    eventMessage: {
      shipmentId: shipId,
      documentDetails: documents_h,
      fullName: userBasicInfo.fullName,
      userType: "BROKER",
    },
    eventType: "ADD_DOCUMENT_NEW",
    eventTime: Date.now(),
  };

  return HttpClient.addDoc({
    data: body,
  });
};

export const attachC88 = (shipId, userBasicInfo) => {
  let documents_h = [];
  documents_h.push({
    documentName: `${shipId.trim()}_c88.pdf`,
    fullProcess: "SKIP OCR",
    documentType: "9",
    replaceOldVersion: true,
    displayName: "C88",
  });

  let body = {
    eventMessage: {
      shipmentId: shipId,
      documentDetails: documents_h,
      fullName: userBasicInfo.fullName,
      userType: "BROKER",
    },
    eventType: "ADD_DOCUMENT_NEW",
    eventTime: Date.now(),
  };

  return HttpClient.custom({
    data: body,
  });
};

export const attachC89 = (shipId, userBasicInfo) => {
  let documents_h = [];
  documents_h.push({
    documentName: `${shipId.trim()}_c89.pdf`,
    fullProcess: "SKIP OCR",
    documentType: "20",
    replaceOldVersion: true,
    displayName: "C89",
  });
  let body = {
    eventMessage: {
      shipmentId: shipId,
      documentDetails: documents_h,
      fullName: userBasicInfo.fullName,
      userType: "BROKER",
    },
    eventType: "ADD_DOCUMENT_NEW",
    eventTime: Date.now(),
  };

  return HttpClient.custom({
    data: body,
  });
};

export const save_as_pdf_apx = (shipId, documentList, docCode, transactionId) => {
  let body = {
    eventMessage: {
      shipmentId: shipId,
      docCode: docCode,
      documentIds: documentList,
    },
    eventType: "SAVE_AS_PDF",
    eventTime: Date.now(),
  };
  if(transactionId){
    body.eventMessage.transactionId = transactionId;
  }

  return HttpClient.addDoc({
    data: body,
  });
};

export const submit_dis_request_apx = (
  shipId,
  documentList,
  cbpRequestId_m,
  userRequestId_m,
  brokerComment
) => {
  let body = {
    eventMessage: {
      shipmentId: shipId,
      actionCode: "ADD",
      completeFileNames: documentList,
      cbpRequestId: cbpRequestId_m,
      userRequestId: userRequestId_m,
      comment: brokerComment,
    },
    eventTime: Date.now(),
    eventType: "SUBMIT_DIS_REQUEST",
  };

  return HttpClient.addDoc({
    data: body,
  });
};
export const submit_FILE_CBSA_DIF_REQUEST_apx = (
  shipId,
  difrequestsArray,
  importerNo
) => {
  let body = {
    eventMessage: {
      difRequests: difrequestsArray,
      txnNumber: window.transactionNumber,
      shipmentId: shipId,
      businessNumber: importerNo,
      useCBSAEnvironment: false,
    },
    eventType: "FILE_CBSA_DIF_REQUEST",
    eventTime: Date.now(),
  };

  return HttpClient.addDoc({
    data: body,
  });
};

export const load_DIS_USER_REQUEST_apx = (shipId) => {
  let body = {
    eventMessage: {
      shipmentId: shipId,
    },
    eventType: "LOAD_DIS_USER_REQUEST",
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data: body,
  });
};

export const create_MOCK_DIS_RESPONSE_apx = (userRequestId_m) => {
  let body = {
    eventMessage: {
      requestId: userRequestId_m,
      messageType: "dr",
      disMockDrDocReviewResult: {
        documentIndex: "0",
        processingEvent: "REVIEW",
        documentReviewStatus: "REJECTED",
        documentRejectReason: "INCORRECT_DOCUMENT_RECEIVED",
        documentReviewComment:
          "Comments from reviewing officer will appear in this data element",
      },
      showResponseXml: "true",
    },
    eventTime: Date.now(),
    eventType: "MOCK_DIS_RESPONSE",
  };

  return HttpClient.custom({
    data: body,
  });
};
export const save_CBSA_DIF_FIELD_apx = (
  fieldName,
  docType,
  value,
  modalrequestid
) => {
  let body = {
    eventMessage: {
      requestid: modalrequestid, //specific to every modal!
      docType: docType,
    },
    eventType: "SAVE_CBSA_DIF_FIELD",
    eventTime: Date.now(),
  };
  body.eventMessage[fieldName] = value;
  return HttpClient.custom({
    data: body,
  });
};

export const search_GET_DIF_DOC_TYPE_apx = (searchTerm, pgaType,subProgramType) => {
  let body = {
    eventMessage: {
      docCode: searchTerm,
      pgaType: pgaType ? pgaType : "",
      pgaSubProgramType:subProgramType ? subProgramType : ""
    },
    eventTime: Date.now(),
    eventType: "GET_DIF_DOC_TYPE",
  };
  return HttpClient.custom({
    data: body,
  });
};

export const search_DIS_DOC_CODES_apx = (searchTerm) => {
  let body = {
    eventMessage: {
      searchTerm: searchTerm,
    },
    eventTime: Date.now(),
    eventType: "SEARCH_DIS_DOC_CODES",
  };

  return HttpClient.custom({
    data: body,
  });
};

export const get_SHIPMENT_DOCUMENTS_BY_DOCTYPE_apx = (shipId) => {
  let body = {
    eventMessage: {
      shipmentId: shipId, //"KX-K2D8-942",
      documentType: [],
    },
    eventType: "GET_SHIPMENT_DOCUMENTS_BY_DOCTYPE",
    eventTime: Date.now(),
  };

  return HttpClient.custom({
    data: body,
  });
};


export const get_CSV_FOR_RECON_PAGE = (reconShipmentId, tabName) => {
  let body = {
    eventMessage: {
      "reconShipmentId": reconShipmentId,
      "tabName": tabName,
      "format": "csv"
    },
    eventType: "RECON_SHIPMENT_GET",
    eventTime: Date.now(),
  };

  return HttpClient.custom({
    data: body,
  });
};


